export default {
    device_status_account: "Cuenta",
    device_status_unit_id: "Id. de la unidad",
    device_status_age: "Edad (Días)",
    device_status_event: "Evento",
    device_status_last_readings: "Última lectura",
    device_status_no_data_message: "No hay datos disponibles",
    device_status_status: "Estado",
    device_status_manufacturer: "Fabricante",
    device_status_serial: "Serial",
}